import React from 'react';
import MaterialCardTitle from 'material-ui/Card/CardTitle';

const CardTitle = (props) => {
    return <MaterialCardTitle { ...props } />;
};

export default CardTitle;



// WEBPACK FOOTER //
// ./src/components/ui/card/CardTitle.js